<alaris-dialog
	[closeAction]="close.bind(this)"
	[confirmAction]="confirm.bind(this)"
	[loading$]="usersService.loading$"
	[confirmButtonText]="'gl.delete'"
	size="md"
	class="removingDialog">
	<h3 slot="header">
		<app-circle-warning></app-circle-warning>
		<div>
			{{ 'users_roles.users.removingDialogTitle' | translate }}
		</div>
	</h3>
	<div slot="content">
		<p>
			{{ 'users_roles.users.userRemoving' | translate }}
			<strong>{{ data.user.Login }}</strong>
		</p>
	</div>
</alaris-dialog>
